<template>
  <div class="pb-3" >
    <va-card :title="$t(`clubs.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(upload)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="club.name"
                  :label="$t('clubs.forms.nameLabel')"
                  :placeholder="$t('clubs.forms.namePlaceholder')"
                  :success="errors.length == 0 && club.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="form-group mt-3 mb-3">
                <va-select
                  :label="$t('clubs.forms.championshipLabel')"
                  v-model="championship"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  :placeholder="$t('clubs.forms.championshipPlaceholder')"
                  :noOptionsText="$t('clubs.forms.championshipNoOption')"
                  maxHeight='200px'
                  :options="championships.length > 0 ? championships : []"
                />
              </div>
              <div v-if='oldLogo.length > 0' class="form-group mt-3">
                <img
                  :src="$store.getters['environment/cdn'] + '/clubs/' + oldLogo"
                  style="height: 30vh; max-width: 100%;"
                >
              </div>
              <ValidationProvider name="Logo" :rules="oldLogo.length > 0 ? '' : 'required'" v-slot="{ errors }">
                <div class="form-group mt-3">
                  <label
                    class="va-input__container__label position"
                    style="color: rgb(108, 127, 238);">
                    {{$t('clubs.forms.logoLabel')}}
                  </label>
                  <va-file-upload
                    type="single"
                    v-model="logo"
                  />
                  <ErrorMessages :errors='errors'/>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" name="ID da API" v-slot="{ errors }">
                <va-input
                  v-model="api"
                  :label="$t('clubs.forms.idApiLabel')"
                  :placeholder="$t('clubs.forms.idApiPlaceholder')"
                  :success="errors.length == 0 && api > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import ErrorMessages from '../utils/ErrorMessages'
import UnicodeData from 'unicharadata'

import gql from 'graphql-tag'
export default {
  name: 'ClubAddUpdate',
  components: { ErrorMessages },
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  computed: {
    api: {
      get () {
        return this.club.idApi
      },
      set (value) {
        if (value >= 0) {
          this.club.idApi = value
        }
      },
    },
  },
  data () {
    return {
      club: {
        name: '',
        logo: '',
        championshipId: '',
        idApi: 0,
      },
      oldLogo: '',
      logo: [],
      championship: '',
      championships: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.club.name = ''
    this.club.logo = ''
    this.club.idApi = 0
    if (this.updateData !== null) {
      this.club_get(this.updateData)
    }
  },
  watch: {
    logo (value) {
      if (value.length > 0) {
        this.club.logo = value[0].name
      }
    },
    updateData (value) {
      if (this.updateData !== null) {
        this.club_get(this.updateData)
      } else {
        this.club.name = ''
        this.club.logo = ''
        this.club.idApi = 0
      }
    },
    championship (value) {
      if (value !== '') {
        this.club.championshipId = value.id
      }
    },
  },
  apollo: {
    championships: {
      query: gql`
      query myquery {
        championships: championship(where: {_or: [{id: {_eq: 1}}, {is_category: {_eq: true}}]}, order_by: {id: asc}) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.championships.length > 0 && this.championship === '') {
            this.championship = Object.assign({}, data.championships[0])
          }
        }
      },
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    club_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'logo') {
            this.oldLogo = data[value]
            this.club[value] = ''
          } else if (value === 'championship') {
            this.championship = data[value]
          } else if (value === 'id_api') {
            this.club.idApi = data[value]
          } else {
            this.club[value] = data[value]
          }
        }
      })
    },
    upload () {
      if (this.club.logo.length !== 0) {
        const formData = new FormData()
        formData.append('file', this.logo[0])
        formData.append('path', 'clubs')
        if (this.updateData !== null) {
          formData.append('deleteFile', this.oldLogo)
        }
        this.$axios.post(
          '/api/upload',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        ).then(resp => {
          this.club.logo = resp.data.filename
          this.onSubmit()
        })
      } else {
        this.club.logo = this.oldLogo
        this.onSubmit()
      }
    },
    sanitizeString (str) {
      const unicharadata = new UnicodeData()
      const text = str.trim().normalize('NFKD')
      let nText = ''
      for (const i in text) {
        nText += !unicharadata.combining(text[i]) ? text[i] : ''
      }
      return nText.includes('-') ? nText.replaceAll(' ', '') : nText.replaceAll(' ', '-')
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, logo, championshipId, idApi } = this.club
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($name: String!, $logo: String!, $championship_id: Int!, $id: Int!, $code: String!, $id_api: Int!) {
                  update_club_by_pk(pk_columns: {id: $id}, _set: {name: $name, logo: $logo, championship_id: $championship_id, code: $code, id_api: $id_api}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String, $logo: String, $championship_id: Int!, $code: String!, $id_api: Int!) {
                  insert_club(objects: {name: $name, logo: $logo, championship_id: $championship_id, code: $code, id_api: $id_api}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            logo,
            championship_id: championshipId,
            id_api: idApi,
            code: this.sanitizeString(name),
            id: this.club.id,
          } : {
            name,
            logo,
            championship_id: championshipId,
            id_api: idApi,
            code: this.sanitizeString(name),
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.club.name = ''
          self.club.logo = ''
          self.club.idApi = 0
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.club.name = ''
          self.club.logo = ''
          self.club.idApi = 0
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
